// extracted by mini-css-extract-plugin
module.exports = {"container":"ModelsTable_container__1eVOA","tableContainer":"ModelsTable_tableContainer__2sGYx"};